<!--
 * @Author: 郑君婵
 * @Description: input-number组件
-->
<template>
    <a-input
      v-bind="$attrs"
      :value="value"
      :disabled="disabled"
      @blur="onBlur"
      @change="onChange" />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: '',
      type: [String, Number]
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 999999999.999,
      type: Number
    },
    precision: {
      default: 3,
      type: Number
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    isValidRange() {
      return this.max > this.min
    }
  },
  methods: {
    onChange({target}) {
      const price = this.formatPrice(target.value)
      this.$emit('change', price)
      target.value = price
    },
    onBlur() {
      this.$emit('blur')
    },
    formatPrice(value) {
      const price = Number(value)
      const isPrice = !Number.isNaN(price)

      if (value === '') {
        // 如果input框没有填写，不作任何处理
        return value
      }

      if (!isPrice) {
        // 如果不是合法的数字，返回之前的有效值
        return this.value
      }

      if (this.isValidRange) {
        // 如果有最大最小值，检查输入值是否在正确的区间
        if (price < this.min) {
          return this.min
        }

        if (price > this.max) {
          return this.max
        }
      }

      if (value.includes('.')) {
        // 如果是小数，校验精度
        return this.formatDecimal(value)
      }

      return value
    },
    formatDecimal(current) {
      const splitList = current.split('.')
      const precision = splitList[1].length

      if (precision > this.precision) {
        return this.value
      }

      return current
    }
  }
}
</script>
